export default __webpack_public_path__ + "static/artifakt-element-italic-b7991c1cc0c3af8c4301f539592219b8.svg";